import { tagCategories } from './utils/helpers';

export const filmFavsConfig = {
  apiPath: '/api/film-favs',
  slug: 'filmfavs',
  title: 'film-favs',
  nameLabel: 'Name',
  artistLabel: null,
  entryTypes: [
    { value: 'film', label: 'Film' },
    { value: 'series', label: 'Serie' }
  ],
  typeFilters: [
    { value: 'both', label: 'both' },
    { value: 'film', label: 'films' },
    { value: 'series', label: 'series' }
  ],
  typeLabels: { film: '🎬 Film', series: '📺 Serie' },
  exportTypeLabels: { film: 'Film', series: 'Serie' },
  tagCategories
};
